import { connect } from 'react-redux';
import DataTable from 'Components/Table/dataTable';

function mapStateToProps(state) {
    const { profile } = state
    return { 
        profile:profile.permission && JSON.parse(profile.permission) 
    };
}

export default connect(mapStateToProps)(DataTable);